"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var AppConfig_1 = require("../../AppConfig");
var SidebarDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    height: 100%;\n    width: ", ";\n    padding: 1rem;\n    box-sizing: border-box;\n    background-color: ", ";\n    color: ", ";\n    overflow-y: auto;\n"], ["\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    height: 100%;\n    width: ", ";\n    padding: 1rem;\n    box-sizing: border-box;\n    background-color: ", ";\n    color: ", ";\n    overflow-y: auto;\n"])), AppConfig_1.UIConfig.SidebarWidth + 'px', AppConfig_1.UIConfig.ThemeColorDarkPurple, AppConfig_1.UIConfig.ThemeColorYellow);
var Sidebar = function (_a) {
    var children = _a.children;
    return (React.createElement(SidebarDiv, null, children));
};
exports.default = Sidebar;
var templateObject_1;
